import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    // 絞り込みモーダル
    var seachBox = $('.c-search-box__box__box');
    var modal = $('.c-search-box__modal');
    var modalBox = $('.c-search-box__modal__content');
    var seachRudio = $('.c-search-box__modal__radio');

    $(seachBox).on('click', function () {
      $(this).next(modal).addClass('is-active');
      $('body').addClass('is-overflow');

    });
    $('.c-search-box__modal__close').on('click', function () {
      $(modal).removeClass('is-active');
      $('body').removeClass('is-overflow');
      var imageName = $('.c-search-box__modal__radio.is-active .c-search-box__modal__image').html();
      $(seachBox).html(imageName);
    });
    $(seachRudio).on('click', function () {
      $(seachBox).addClass('is-selected');
      $(seachRudio).removeClass('is-active');
      $(this).addClass('is-active');
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.c-search-box__modal__content,.c-search-box__box__box').length) {
        $('body').removeClass('is-overflow');
        $(modal).removeClass('is-active');
        var imageName = $('.c-search-box__modal__radio.is-active .c-search-box__modal__image').html();
        $(seachBox).html(imageName);
      }
      ;
    });

    // メインビジュアル
    if ($('.c-main-visual').length !== 0) {
      var owls = $('.c-main-visual.owl-carousel');
      owls.imagesLoaded(function () {
        owls.owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          //nav: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoplayTimeout: 5000,
          center: true,
          responsive: {
            0: {
              items: 1,
              autoWidth: false,
              navText: ['<img src="/wp-content/themes/nf-corporation-html/dist/assets/images/icon-slider-prev_sp.png" />', '<img src="/wp-content/themes/nf-corporation-html/dist/assets/images/icon-slider-next_sp.png" />'],
            },
            1212: {
              items: 1,
              autoWidth: true,
              navText: ['<img src="/wp-content/themes/nf-corporation-html/dist/assets/images/icon-slider-prev.png" />', '<img src="/wp-content/themes/nf-corporation-html/dist/assets/images/icon-slider-next.png" />'],
            }
          }
        });
      });
    }

    $(".c-products-page__sub").hover(function () {
      var imageName = $(this).children('img').attr("src");
      $('.c-products-page__sub').removeClass('is-active');
      $(this).addClass('is-active');
      $('.c-products-page__main').children('img').attr('src', imageName);
    })

    $(".js-footer-accordion").on('click', function () {
      var win = $(window).innerWidth();
      if (win < 950) {
        event.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.l-footer__menu__list').slideToggle();
      }
    })
    $(".c-sidemenu__title").on('click', function () {
      var win = $(window).innerWidth();
      if (win < 950) {
        event.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.c-sidemenu__list').slideToggle();
      }
    })
    // 費用目安のイメージマップ
    $("#ImageMap area").hover(function () {
      var dataPrice = $(this).data('price');
      var dataDate = $(this).data('date');
      var dataName = $(this).data('name');
      $('.c-map-expense__box__name').text(dataName);
      $('.c-map-expense__box__price span').text(dataPrice);
      $('.c-map-expense__box__date').text(dataDate);
    });
    $('.c-map-expense__select').change(function () {
      var dataPrice = $(".c-map-expense__select option:selected").data("price");
      var dataDate = $(".c-map-expense__select option:selected").data("date");
      var dataName = $(".c-map-expense__select option:selected").data("name");
      console.log(dataPrice);
      $('.c-map-expense__box__name').text(dataName);
      $('.c-map-expense__box__price span').text(dataPrice);
      $('.c-map-expense__box__date').text(dataDate);
    })

    // フローティングバナー
    $('.c-fixed-bnr-sp__close a').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.c-fixed-bnr-sp').addClass('is-close');
      $('.l-footer').css('margin-bottom', 0);
    });

    // $('.c-fixed-bnr').clone(true).appendTo('#clone');
    // var documentHeight = $(document).height(); //ページ全体の高さ
    // var footerTop = $('.c-footer-bnr').height(); //フッターの高さ
    // var contentTop = $('.l-footer').height(); //コンタクトブロックの高さ
    //
    // // 表示する/非表示のオフセット値
    // var visibleOffset = 500; //表示させる座標
    // var hiddenOffset = documentHeight - (footerTop - contentTop + 1500); //非表示にする座標
    // //スクロールイベントが発生したら処理実行
    // $(window).on('scroll', function () {
    //
    //   //表示
    //   if ($(this).scrollTop() > visibleOffset) {
    //     $('#clone .c-fixed-bnr').addClass('is-fixed');
    //   }
    //
    //   //非表示
    //   if ($(this).scrollTop() > hiddenOffset) {
    //     $('#clone .c-fixed-bnr').removeClass('is-fixed');
    //   }
    //
    //   //表示
    //   if ($(this).scrollTop() < visibleOffset) {
    //     $('#clone .c-fixed-bnr').removeClass('is-fixed');
    //   }
    // });
  }
}

window.GApp = new App();
